const LogoWithoutText = () => {
  return (
    <svg
      width="40"
      height="48"
      viewBox="0 0 40 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5934 22.3275C19.4068 22.3275 18.2922 21.5931 17.8602 20.4152C17.3102 18.9061 18.0878 17.2386 19.5969 16.6885C22.4164 15.6632 24.9537 14.2578 26.7421 12.7371C28.4212 11.3086 28.8042 10.3064 28.8273 10.0616C28.3146 8.56688 29.0893 6.92816 30.5841 6.38672C32.0932 5.83664 33.7607 6.61424 34.3108 8.12336C34.8695 9.6584 35.2065 12.7947 31.1889 16.5618C28.833 18.7707 25.4231 20.755 21.587 22.1518C21.2586 22.2699 20.9217 22.3275 20.5934 22.3275Z"
        fill="url(#paint0_linear_351_48)"
      />
      <path
        d="M31.5979 12.0201C30.4286 12.0201 29.3284 11.3088 28.8849 10.1597C28.7064 9.98685 27.756 9.46557 25.5384 9.45405C23.1825 9.44253 20.3313 10.0013 17.5147 11.0265C16.0056 11.5766 14.338 10.799 13.788 9.28989C13.2379 7.78077 14.0155 6.11325 15.5246 5.56317C19.3636 4.16637 23.2574 3.49245 26.4888 3.66525C32.0068 3.96189 33.7694 6.57981 34.3281 8.11485C34.8782 9.62397 34.1006 11.2915 32.5915 11.8416C32.2632 11.9597 31.9262 12.0173 31.5979 12.0173V12.0201Z"
        fill="url(#paint1_linear_351_48)"
      />
      <path
        d="M7.88301 27.837C6.69645 27.837 5.58189 27.1026 5.14989 25.9246C3.50541 21.4059 3.76749 17.0168 5.91021 13.2325C6.89517 11.4901 8.25453 9.93776 9.94797 8.61296C11.5579 7.3544 13.4356 6.32912 15.5265 5.56592C17.0356 5.01584 18.7032 5.79344 19.2532 7.30256C19.8033 8.81168 19.0257 10.4792 17.5166 11.0293C14.5329 12.115 12.2088 13.915 10.9732 16.0981C9.67725 18.3877 9.55629 21.0229 10.619 23.9374C11.1691 25.4466 10.3915 27.1141 8.88237 27.6642C8.55405 27.7822 8.21709 27.8398 7.88877 27.8398L7.88301 27.837Z"
        fill="url(#paint2_linear_351_48)"
      />
      <path
        d="M19.2706 36.1314C17.3813 36.1314 15.587 35.8233 13.9253 35.2156C9.83568 33.718 6.7944 30.5068 5.12976 25.9305C4.57968 24.4213 5.35728 22.7538 6.8664 22.2037C8.37552 21.6537 10.043 22.4313 10.5931 23.9404C11.6674 26.8953 13.4616 28.8508 15.924 29.7551C18.2568 30.6105 21.2002 30.4751 24.2126 29.3807C25.7218 28.8306 27.3893 29.6082 27.9394 31.1173C28.4894 32.6265 27.7118 34.294 26.2027 34.8441C24.109 35.6073 22.0181 36.0335 19.9906 36.117C19.7486 36.1257 19.5067 36.1314 19.2706 36.1314Z"
        fill="url(#paint3_linear_351_48)"
      />
      <path
        d="M3.52824 15.9341C2.34168 15.9341 1.22712 15.1997 0.795118 14.0218C-0.711121 9.88322 -0.0573621 5.24354 2.58648 1.2893C3.48216 -0.0441369 5.28504 -0.401257 6.62136 0.491543C7.9548 1.38434 8.3148 3.1901 7.41912 4.52354C5.81784 6.9197 5.39448 9.6557 6.25848 12.0317C6.80856 13.5408 6.03096 15.2083 4.52184 15.7584C4.19352 15.8765 3.85656 15.9341 3.52824 15.9341Z"
        fill="#5CFFEF"
      />
      <path
        d="M15.1747 23.3011C13.1126 23.3011 11.0851 22.944 9.18429 22.2326C7.24605 21.5069 5.54397 20.4499 4.12125 19.0906C2.61789 17.6534 1.50045 15.9485 0.797732 14.0218C0.247653 12.5126 1.02525 10.8451 2.53437 10.295C4.04349 9.74499 5.71101 10.5226 6.26109 12.0317C7.04733 14.1946 8.80989 15.8822 11.2262 16.7866C13.8009 17.7514 16.7731 17.7168 19.5984 16.6886C21.1075 16.1386 22.775 16.9162 23.3251 18.4253C23.8752 19.9344 23.0976 21.6019 21.5884 22.152C19.4889 22.9152 17.3145 23.2982 15.1776 23.2982L15.1747 23.3011Z"
        fill="url(#paint4_linear_351_48)"
      />
      <path
        d="M12.2028 39.7545C11.0162 39.7545 9.90169 39.0201 9.46969 37.8421C8.76985 35.9154 8.52793 33.8908 8.75833 31.823C8.97433 29.8674 9.59929 27.9609 10.6159 26.1609C12.6492 22.5609 16.0418 19.75 20.166 18.2495C21.6751 17.6994 23.3426 18.477 23.8927 19.9862C24.4428 21.4953 23.6652 23.1628 22.1561 23.7129C19.3308 24.741 17.0297 26.6246 15.679 29.0207C14.4118 31.2671 14.1468 33.6921 14.933 35.855C15.4831 37.3641 14.7055 39.0316 13.1964 39.5817C12.8681 39.6998 12.5311 39.7574 12.2028 39.7574V39.7545Z"
        fill="url(#paint5_linear_351_48)"
      />
      <path
        d="M36.1972 24.718C35.025 24.718 33.9277 24.0066 33.4842 22.8546C33.3085 22.6818 32.3725 22.1605 30.1664 22.1461C27.8192 22.1288 24.9738 22.6876 22.1514 23.7128C20.6423 24.2629 18.9748 23.4853 18.4247 21.9762C17.8746 20.4671 18.6522 18.7996 20.1613 18.2495C23.9975 16.8527 27.8855 16.1816 31.1111 16.3602C36.609 16.6626 38.3687 19.2834 38.9274 20.8184C39.4775 22.3276 38.6999 23.9951 37.1908 24.5452C36.8624 24.6632 36.5255 24.7208 36.1972 24.7208V24.718Z"
        fill="url(#paint6_linear_351_48)"
      />
      <path
        d="M25.2105 35.0197C24.024 35.0197 22.9094 34.2853 22.4774 33.1073C21.9273 31.5982 22.7049 29.9307 24.2141 29.3806C27.0336 28.3553 29.5709 26.9499 31.3593 25.4293C33.0384 24.0008 33.4214 22.9985 33.4445 22.7537C32.9318 21.259 33.7065 19.6203 35.2013 19.0789C36.7104 18.5288 38.3779 19.3064 38.928 20.8155C39.4867 22.3505 39.8237 25.4869 35.8061 29.2539C33.4502 31.4629 30.0403 33.4472 26.2041 34.844C25.8758 34.9621 25.5389 35.0197 25.2105 35.0197Z"
        fill="url(#paint7_linear_351_48)"
      />
      <path
        d="M23.8505 47.1214C21.7884 47.1214 19.7609 46.7643 17.8601 46.053C15.9218 45.3272 14.2198 44.2702 12.797 42.9109C11.2937 41.4738 10.1762 39.7688 9.47351 37.8421C8.92343 36.333 9.70103 34.6654 11.2102 34.1154C12.7193 33.5653 14.3868 34.3429 14.9369 35.852C15.7231 38.0149 17.4857 39.7026 19.902 40.6069C22.4767 41.5717 25.4489 41.5371 28.2741 40.509C29.7833 39.9589 31.4508 40.7365 32.0009 42.2456C32.5509 43.7547 31.7733 45.4222 30.2642 45.9723C28.1647 46.7355 25.9903 47.1186 23.8533 47.1186L23.8505 47.1214Z"
        fill="url(#paint8_linear_351_48)"
      />
      <path
        d="M29.2652 46.1509C28.0787 46.1509 26.9641 45.4165 26.5321 44.2386C25.982 42.7295 26.7596 41.0619 28.2687 40.5119C29.6627 40.0021 32.3267 38.7867 33.5391 37.6923C34.7315 36.6181 36.5718 36.7131 37.646 37.9083C38.7203 39.1007 38.6252 40.941 37.43 42.0152C34.982 44.2213 30.734 45.8053 30.2588 45.9781C29.9305 46.0962 29.5935 46.1538 29.2652 46.1538V46.1509Z"
        fill="url(#paint9_linear_351_48)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_351_48"
          x1="17.6846"
          y1="14.2693"
          x2="34.642"
          y2="14.2693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55E9F1" />
          <stop offset="1" stopColor="#4ED2F2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_351_48"
          x1="13.6123"
          y1="7.82973"
          x2="26.3563"
          y2="7.82973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47BCF4" />
          <stop offset="0.26" stopColor="#4BCAF2" />
          <stop offset="0.49" stopColor="#4ED2F2" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_351_48"
          x1="6.44589"
          y1="22.7106"
          x2="15.0744"
          y2="8.04272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47BCF4" />
          <stop offset="0.54" stopColor="#4BCAF2" />
          <stop offset="1" stopColor="#4ED2F2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_351_48"
          x1="4.95408"
          y1="29.0812"
          x2="28.1179"
          y2="29.0812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47BCF4" />
          <stop offset="1" stopColor="#2A62FA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_351_48"
          x1="0.619173"
          y1="16.7088"
          x2="23.4979"
          y2="16.7088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5CFFEF" />
          <stop offset="1" stopColor="#55E9F1" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_351_48"
          x1="11.4108"
          y1="34.4495"
          x2="18.7462"
          y2="21.5068"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#234CFC" />
          <stop offset="1" stopColor="#3179F9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_351_48"
          x1="18.2519"
          y1="20.5247"
          x2="39.106"
          y2="20.5247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3179F9" />
          <stop offset="1" stopColor="#398FF7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_351_48"
          x1="22.3017"
          y1="26.9614"
          x2="39.2592"
          y2="26.9614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3179F9" />
          <stop offset="1" stopColor="#398FF7" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_351_48"
          x1="9.29495"
          y1="40.532"
          x2="32.1737"
          y2="40.532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#234CFC" />
          <stop offset="1" stopColor="#1C35FD" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_351_48"
          x1="26.3593"
          y1="41.5487"
          x2="38.3948"
          y2="41.5487"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C35FD" />
          <stop offset="1" stopColor="#151FFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoWithoutText;
